//Core
import React, { useState } from "react"

//Components
import InputSimple from "./InputPhone"
import Button from "./Button"
import CheckBox from "./CheckBox"

//UI
import Spinner from "../../../components/UI/Spinner"
import { onSucces, onFail } from "../../../components/UI/PopUp"

//Helpers
import { classes } from "../../../helpers/classname"

//Hooks
import useForm from "../../../FormHooks/travelHook"

//Style
import style from "./style.module.scss"

const { Container, FormWrapper, CheckBoxWrapper } = style

const PudraForm = ({ link, product }) => {
  const [checked, setChecked] = useState(true)

  const { state, changePhone, chackedPhone, onClick } = useForm(link)
  const { phone, fetch, success, fail } = state

  const toogleCheckBox = () => {
    setChecked(!checked)
  }

  return fetch ? (
    <Spinner />
  ) : (
    <>
      <div id="form" className={classes(Container)}>
        <form
          className={classes(FormWrapper)}
          onSubmit={e => {
            e.preventDefault()
            onClick()
          }}
        >
          <InputSimple
            value={phone.value}
            haveInitial={phone.haveInitial}
            full={false}
            change={changePhone}
            change={changePhone}
            chakedFunc={chackedPhone}
            checked={phone.checked}
            valid={phone.valid}
            message={"Перевірте правильність вводу номера мобільного телефону"}
            placeholder={`Ваш номер телефону`}
          ></InputSimple>
        </form>
        <div className={CheckBoxWrapper}>
          <CheckBox checked={checked} click={toogleCheckBox}></CheckBox>
        </div>

        <Button onClick={onClick} checked={checked}></Button>
      </div>

      {success ? onSucces(`Дякуємо! Очікуйте смс протягом 3 хвилин`) : null}
      {fail ? onFail() : null}
    </>
  )
}

export default PudraForm
